import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useQuestionSectionStyle = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginTop: "20px",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
    marginTop: "10px",
    },
  },
  paper: {
    paddingTop: "40px",
    paddingBottom: "40px",
    height: "calc(100vh - 320px)",
    overflow: "auto",
    boxShadow: "none !important",
    [theme.breakpoints.down("sm")]: {
      padding: "0px",
    },
    "&::-webkit-scrollbar": {
      width: "0px",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
    },
  },
  questionContainer: {
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
    },
  },
  questionTitle: {
    fontWeight: "bold",
    padding: "0px 0px 4px 0px",
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid black",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.5rem", // 70% font size
    },
  },
  upWrapper: {
    padding: "4px 0px 30px 0px",
    display: "flex",
    justifyContent: "end",
    marginTop: "16px",
    borderTop: "1px solid black",
    alignSelf: "baseline",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
    },
  },
  givenSection: {
    marginBottom: "16px",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
    },
  },
  finalReaction: {
    margin: "16px 0",
    fontWeight: "500",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
    },
  },
  scrollableContent: {
    maxHeight: "400px",
    overflowY: "auto",
    marginBottom: "10px",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
    },
  },
 buttonGroup: {
    display: "flex",
    flexWrap: "nowrap",
    gap: "8px",
    justifyContent: "space-between",
    paddingBottom: "10px",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      "& button": {
        flex: "1 1 calc(50% - 8px)",
      },
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      gap: "5.6px", // 70% of 8px
      paddingBottom: "7px", // 70% of 10px
      "& button": {
        fontSize: "0.7rem !important", // 70% font size
        padding: "4.2px 8.4px !important", // 70% of 6px 12px
        minWidth: "auto !important",
      },
    },
  },
  navButtons: {
    position: "sticky",
    marginTop: "20px",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
    zIndex: 10,
    padding: "10px 24px",
    boxShadow: "0px -2px 10px rgba(0,0,0,0.1)",
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      marginTop: "14px", // 70% of 20px
      padding: "7px 16.8px", // 70% of 10px 24px
      "& .MuiStack-root": {
        gap: "5.6px", // 70% of 8px
      },
    },
    "@media (min-width: 992px)": {
      marginTop: "14px", // 70% of 20px
      padding: "7px 16.8px", // 70% of 10px 24px
      "& .MuiStack-root": {
        gap: "5.6px", // 70% of 8px
      },
    },
  },
  finalpopup: {
    padding: "1rem 1rem 0 1rem",
    "& .MuiTypography-h6": {
      color: "#263238",
      fontFamily: "Satoshi",
      fontSize: "2rem",
      fontStyle: "normal",
      fontWeight: "700",
      textTransform: "capitalize",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
      "& .MuiTypography-h6": {
        fontSize: "1.4rem", // 70% of 2rem
      },
    },
  },
  p1: {
    padding: "1rem",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
    },
  },
  contentContainer: {
    width: "100%",
    padding: "10px",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem", // 70% font size
    },
  },
}));

export default useQuestionSectionStyle;